import React from 'react';
import {
  TableCell,
  TextField,
  Button,
  Grid
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import FancyDropDown from '../../FancyDropDown';
import { inputFieldNames } from '../../../constants';
import { hazardHierarchy } from '../../../constants';
import DocumentListDialog from '../../../containers/DocumentListDialog';

import LibraryDocumentList from '../../LibraryDocumentList';
import {addDocumentToArray, removeDocumentFromArray} from "../../../mappers/libraryDocumentMapper";

import config from '../../../constants/blob_config.json';

const useStyles = makeStyles((theme) => ({
  cancelButton: {
    marginLeft: 10,
    color: theme.palette.subTitle.main
  },
  addAttachmentFab: {
    margin: theme.spacing(1),
    marginLeft: 0
  },
  fab: {
    margin: theme.spacing(1)
  },
  button: {
    margin: theme.spacing(1),
    width: 210,
    height: '36px !important',
    borderWidth: 1.3,
    flex: 1
  },
  extendedIcon: {
    marginRight: theme.spacing(1)
  }
}));

const EditHazardControl = (props) => {
  const classes = useStyles();
  const {
    control,
    userId,
    handleEditHazardControlInputChange,
    enableEditHazardControl,
    handleSaveHazardControlClick,
    openDocumentListDialog
  } = props;



  const handleDocumentSelected = (documentLink) => {
    const {document} = control;
    const updatedDocument = addDocumentToArray(document, documentLink);
    handleEditHazardControlInputChange(updatedDocument,  inputFieldNames.HAZARD_CONTROL_DOCUMENT);
  };

  const handleDocumentRemove = (documentToRemove) => {
    const {document} = control;
    const updatedDocument = removeDocumentFromArray(document, documentToRemove);
    handleEditHazardControlInputChange(updatedDocument, inputFieldNames.HAZARD_CONTROL_DOCUMENT);
  }

  const canEditDocuments = true;

  return (
    <React.Fragment>
         <DocumentListDialog handleDocumentSelected={handleDocumentSelected} showDropdown={true} />
      <TableCell component="th" scope="row">
        <FancyDropDown
          htmlId="hazardHierarchy"
          label="Hierarchy"
          margin="normal"
          value={control.hierarchy}
          handleChange={(e) =>
            handleEditHazardControlInputChange(
              e,
              inputFieldNames.CONTROL_HIERARCHY
            )
          }
          items={hazardHierarchy.hazardHierarchy}
          dropDownWidth="100%"
          className={classes.dropDown}
          valueField="id"
          displayField="value"
          required={true}
        />
      </TableCell>
      <TableCell component="th" scope="row">
        <TextField
          id="controlComments"
          label="Comments"
          onChange={(e) =>
            handleEditHazardControlInputChange(
              e,
              inputFieldNames.CONTROL_COMMENTS
            )
          }
          value={control.comments}
          fullWidth={true}
        />
      </TableCell>

      <TableCell component="th" scope="row" align="center">
        <React.Fragment>
          <Grid container> 
          {/***************** Attachment ******************/}
        {canEditDocuments ? (
                <Grid item xs={9}>
                  <TextField
                    type="text"
                    placeholder="Browse document"
                    defaultValue={control.document}
                    variant="outlined"
                    inputProps={{ readOnly: true }}
                    fullWidth
                    value={control.document}
                  />
                  <LibraryDocumentList commeSeperatedDocument = {control.document} onRemoveDocument = {handleDocumentRemove} canEdit={canEditDocuments}/>
                </Grid>
              ) : (
                <Grid item xs={12}>
                  <LibraryDocumentList commeSeperatedDocument = {control.document} onRemoveDocument = {handleDocumentRemove} canEdit={canEditDocuments}/>
                </Grid>
              )}
              {canEditDocuments && (
                <Grid item xs={3}>
                  <Button
                    color="primary"
                    variant="contained"
                    className={(classes.documentButton, classes.browseButton)}
                    id="seeDocumentButon"
                    onClick={openDocumentListDialog}
                  >
                    {'Browse'}
                  </Button>
                </Grid>
              )}
              </Grid>
        </React.Fragment>
        
      </TableCell>

      <TableCell component="th" scope="row" align="center">
        <React.Fragment>
          <Button
            onClick={handleSaveHazardControlClick}
            color="primary"
            variant="outlined"
            className={classes.actionButton}
            id="saveButton"
          >
            Save
          </Button>
          <Button
            onClick={() =>
              enableEditHazardControl(false, control.id, userId.id)
            }
            className={classes.cancelButton}
            id="cancelButton"
          >
            Cancel
          </Button>
        </React.Fragment>
      </TableCell>
    </React.Fragment>
  );
};

export default EditHazardControl;
